'use strict';

function fSliderCards () {
    const aSliders = document.querySelectorAll('.js-slider-cards');

    function fSetGroupcells (isEvents) {
        if (window.innerWidth < 800) {
            return 1;
        } else if (window.innerWidth < 1200) {
            return 2;
        } else if (window.innerWidth < 1700) {
            return isEvents ? 2 : 3;
        } else {
            return isEvents ? 3 : 4;
        }
    }

    function fInitSlider (oSlider) {
        const oList = oSlider.querySelector('.js-slider-list');
        const oNav = oSlider.querySelector('.js-slider-nav');
        const oTextblock = oSlider.querySelector('.js-slider-cards-textblock');
        const oButtonPrev = oSlider.querySelector('.js-slider-prev');
        const oButtonNext = oSlider.querySelector('.js-slider-next');
        const isEvents = oList.hasAttribute('data-events');

        let oFlickity = new Flickity(oList, {
            cellAlign: 'left',
            draggable: true,
            contain: true,
            groupCells: fSetGroupcells(isEvents),
            freeScroll: false,
            prevNextButtons: false,
            watchCSS: true,
            on: {
                ready: function () {
                    if (oNav) oNav.style.display = 'block';
                    if (oButtonPrev) oButtonPrev.addEventListener('click', function () { oFlickity.previous(); });
                    if (oButtonNext) oButtonNext.addEventListener('click', function () { oFlickity.next(); });

                    if (this.options.groupCells >= this.cells.length && oButtonNext) {
                        oButtonNext.style.display = 'none';
                    }

                },
                change: function (index) {
                    if (oButtonNext) {
                        if (oFlickity.selectedIndex + 1 === oFlickity.slides.length) {
                            oButtonNext.style.opacity = 0;
                        } else {
                            oButtonNext.style.opacity = 1;
                        }
                    }

                    if (oButtonPrev) {
                        if (index > 0) {
                            oButtonPrev.style.opacity = 1;
                        } else {
                            oButtonPrev.style.opacity = 0;
                        }
                    }
                }
            }
        });

        window.addEventListener('resize', function () {
            oFlickity.options.groupCells = fSetGroupcells(isEvents);

            if (oButtonNext) {
                if (oFlickity.options.groupCells < oFlickity.cells.length) {
                    oButtonNext.style.display = 'block';
                } else {
                    oButtonNext.style.display = 'none';
                }
            }
        });

        let iCalculatedOpacity;

        function fPosToNeg (number) {
            return Math.abs(number);
        }

        function fAnimateTextblock () {
            if (window.innerWidth < 992) return;

            oTextblock.style.transitionDuration = '0s';
            iCalculatedOpacity = (2 / (fPosToNeg(oFlickity.dragX) / 100)) - 1;

            oTextblock.style.opacity = iCalculatedOpacity;

            if ((oFlickity.dragX / 2) > -100 && (oFlickity.dragX / 2) < 0) {
                oTextblock.style.transform = 'translateX(' + (oFlickity.dragX / 2) + 'px)';
            }
        }

        if (oTextblock) {
            oFlickity.on('change', function (index) {
                if (window.innerWidth < 992) return;

                if (index > 0) {
                    oTextblock.setAttribute('style', '');
                    oTextblock.style.transitionDuration = '.4s';
                    oTextblock.style.opacity = 0;
                    oButtonPrev.style.opacity = 1;
                } else {
                    oTextblock.style.transitionDuration = '1s';
                    oTextblock.style.opacity = 1;
                    oButtonPrev.style.opacity = 0;
                }
            });

            oFlickity.on('dragMove', fAnimateTextblock);
        }
    }

    for (let a = 0; a < aSliders.length; a += 1) {
        fInitSlider(aSliders[a]);
    }
}